// config/env.ts
function trimTrailingSlash(value: string): string {
  return value.endsWith("/") ? value.slice(0, -1) : value;
}

function requireEnv(
  value: string | undefined,
  fallback: string,
  name: string
): string {
  const resolved = value?.trim() || fallback;
  if (!resolved) {
    throw new Error(`Missing environment variable: ${name}`);
  }
  return resolved;
}

export const env = {
  apiBaseUrl: trimTrailingSlash(
    requireEnv(
      process.env.NEXT_PUBLIC_API_URL,
      "http://localhost:8080/api",
      "NEXT_PUBLIC_API_URL"
    )
  ),

  mqttBrokerUrl: requireEnv(
    process.env.NEXT_PUBLIC_MQTT_BROKER_URL,
    "wss://sae.somayar.com:9001",
    "NEXT_PUBLIC_MQTT_BROKER_URL"
  ),
  mqttBrokerUsername: requireEnv(
    process.env.NEXT_PUBLIC_MQTT_BROKER_USERNAME,
    "somayar",
    "NEXT_PUBLIC_MQTT_BROKER_USERNAME"
  ),
  mqttBrokerPassword: requireEnv(
    process.env.NEXT_PUBLIC_MQTT_BROKER_PASSWORD,
    "somayar@2026_",
    "NEXT_PUBLIC_MQTT_BROKER_PASSWORD"
  ),

  mqttLiveStatusTopic: requireEnv(
    process.env.NEXT_PUBLIC_MQTT_LIVE_STATUS_TOPIC,
    "live/status/+",
    "NEXT_PUBLIC_MQTT_LIVE_STATUS_TOPIC"
  ),

  mqttLiveV2FleetTopic: requireEnv(
    process.env.NEXT_PUBLIC_MQTT_LIVE_V2_FLEET_TOPIC,
    "horizon/live/v2/fleet/+",
    "NEXT_PUBLIC_MQTT_LIVE_V2_FLEET_TOPIC"
  ),

  mqttLiveV2JourneyTopic: requireEnv(
    process.env.NEXT_PUBLIC_MQTT_LIVE_V2_JOURNEY_TOPIC,
    "horizon/live/v2/journeys/+",
    "NEXT_PUBLIC_MQTT_LIVE_V2_JOURNEY_TOPIC"
  ),

  mqttLiveV2PccLiveTopic: requireEnv(
    process.env.NEXT_PUBLIC_MQTT_LIVE_V2_PCC_LIVE_TOPIC,
    "horizon/live/v2/pcc/live/+",
    "NEXT_PUBLIC_MQTT_LIVE_V2_PCC_LIVE_TOPIC"
  ),

  mqttLiveV2EventTopic: requireEnv(
    process.env.NEXT_PUBLIC_MQTT_LIVE_V2_EVENT_TOPIC,
    "horizon/live/v2/events/+",
    "NEXT_PUBLIC_MQTT_LIVE_V2_EVENT_TOPIC"
  ),

  mqttMessageOutboxTopic: requireEnv(
    process.env.NEXT_PUBLIC_MQTT_MESSAGE_OUTBOX_TOPIC,
    "pcc/messages/outbox/+",
    "NEXT_PUBLIC_MQTT_MESSAGE_OUTBOX_TOPIC"
  ),

  mqttMessageStatusTopic: requireEnv(
    process.env.NEXT_PUBLIC_MQTT_MESSAGE_STATUS_TOPIC,
    "pcc/messages/status/+",
    "NEXT_PUBLIC_MQTT_MESSAGE_STATUS_TOPIC"
  ),

  superAdminRoleName:
    process.env.NEXT_PUBLIC_SUPERADMIN_ROLE_NAME || "ROLE_SUPER_ADMIN",

  superAdminEmail:
    process.env.NEXT_PUBLIC_SUPERADMIN_USER_EMAIL || "admin@horizon.ma",
} as const;